import "./EditSettlementAccount.scss";
import primaryComponents from "../../primaryComponents";
import secondaryComponents from "..";
import EditSettlementAccountLogic from "./EditSettlementAccountLogic";
import EditSettlementAccountValidation from "./EditSettlementValidation";
import { Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EditSettlementAccount = ({
  isOpen = false,
  setIsOpen = () => {},
  settlementAccount,
  handleFetchSettlementAccounts,
}) => {
  const {
    isFetchingBankList,
    bank,
    bankList,
    account_number,
    accountDetails,
    isResolvingAccount,
    isUpdatingAccount,
    is_primary,
    isEdited,
    business_id,
    business_list,
    // setBusinessList,
    setBusinessId,
    setIsEdited,
    setIsPrimary,
    setAccountNumber,
    setBank,
    handleResolveAccountNumber,
    handleUpdateSettlementAccount,
  } = EditSettlementAccountLogic(
    setIsOpen,
    settlementAccount,
    handleFetchSettlementAccounts,
  );

  const {
    control,
    register,
    trigger,
    formState: { errors },
    handleSubmit,
  } = EditSettlementAccountValidation({
    account_number,
    bank,
    business_id,
  });

  return (
    <secondaryComponents.Modal
      isActive={isOpen}
      width="500px"
      closeModal={() => setIsOpen(false)}
    >
      <div className="edit-settlement-account">
        <h4 className="font-weight-semibold text-center mb-3">
          Edit bank account
        </h4>

        <form
          onSubmit={handleSubmit(handleUpdateSettlementAccount)}
          className="add-settlement-account__form"
        >
          {/* <primaryComponents.SelectField
            control={control}
            label="Account Currency"
            isRequired={true}
            placeholder="Select currency"
            name="account_currency"
            options={[`${currency_code}`]}
            value={
              account_currency === "" ? "Select currency" : account_currency
            }
            errorMessage={errors.account_currency}
            onChange={(value) => {
              setIsEdited(true);
              setAccountCurrency(value);
            }}
          /> */}

          {business_list?.length > 0 && (
            <primaryComponents.SelectFieldV2
              label={"Select Sub Account"}
              control={control}
              isRequired={true}
              placeholder="Select account"
              options={business_list}
              idKey="id"
              nameKey="tag"
              name="business_id"
              value={
                business_list?.find(
                  (business) => `${business?.id}` === `${business_id}`,
                )?.tag || "Select account"
              }
              errorMessage={errors.business_id}
              onChange={(value) => {
                setBusinessId(value);
              }}
            />
          )}

          <secondaryComponents.LoaderHelper
            classNames={"py-1"}
            isLoading={isFetchingBankList}
          >
            <primaryComponents.SelectFieldV2
              control={control}
              label="Bank"
              isRequired={true}
              placeholder="Select bank"
              name="bank"
              nameKey={"bank_name"}
              idKey={"bank_code"}
              options={bankList}
              value={
                bankList?.find((bankInfo) => `${bankInfo?.bank_code}` === bank)
                  ?.bank_name || "Select bank"
              }
              errorMessage={errors.bank}
              onChange={(value) => {
                setIsEdited(true);
                setBank(value);
              }}
            />
          </secondaryComponents.LoaderHelper>

          <div style={{ position: "relative" }}>
            <primaryComponents.InputFieldV2
              control={control}
              label="Account Number"
              isRequired={true}
              placeholder="Enter your account number"
              name="account_number"
              errorMessage={errors.account_number}
              register={register}
              onKeyUp={() =>
                errors.account_number !== undefined && trigger("account_number")
              }
              onChange={({ target: { value } }) => {
                setIsEdited(true);
                setAccountNumber(value);
                if (value.length === 10) {
                  handleResolveAccountNumber(value, bank);
                }
              }}
            />

            {accountDetails !== null && (
              <p className="purple--text mb-3">{accountDetails.account_name}</p>
            )}
            {isResolvingAccount && (
              <FontAwesomeIcon
                style={{
                  position: "absolute",
                  right: "10px",
                  // bottom: "50%",
                  top: "45%",
                  transform: "translateY(-50%)",
                }}
                icon={["fas", "spinner"]}
                spin
              />
            )}
          </div>

          <div className="d-flex">
            <Controller
              name="is_primary"
              control={control}
              defaultValue={is_primary}
              render={({ field: { onChange } }) => (
                <primaryComponents.Checkbox
                  name="is_primary"
                  id="is_primary"
                  isChecked={is_primary}
                  onChange={(value) => {
                    onChange(value);
                    setIsPrimary(value);
                  }}
                />
              )}
            />
            <p className="ml-2">Make this my primary bank account</p>
          </div>
          <div className="add-settlement-account__form__actions">
            <primaryComponents.Button
              classNames={"btn btn--outline"}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames={"btn btn--primary"}
              isDisabled={!isEdited || isResolvingAccount}
              isLoading={isUpdatingAccount}
              loadingText="Adding account..."
            >
              Add new bank
            </primaryComponents.Button>
          </div>
        </form>
      </div>
    </secondaryComponents.Modal>
  );
};

export default EditSettlementAccount;
